import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone-fill 296",
  "use": "icon-phone-fill 296-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-phone-fill 296\"><path d=\"M661.333333 768v64H362.666667v-64h298.666666z m149.333334-576a64 64 0 0 1 64 64v405.333333a64 64 0 0 1-64 64H213.333333a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64h597.333334z m-149.333334 234.666667H362.666667v64h298.666666v-64z\" p-id=\"20831\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol